import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {Spinner} from "react-bootstrap";
import {formType} from "../../../../constants/form-type.constants";

class UserForm extends Component {

    state = {
        loading: false,
        id: null,
        username: null,
        firstName: null,
        lastName: null,
        email: null,
        roleId: null,
        allRoles: []
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.getById !== this.props.getById) {
            const { getById } = this.props;
            this.setState({
                id: getById.id,
                username: getById.username,
                firstName: getById.firstName,
                lastName: getById.lastName,
                email: getById.email,
                roleId: getById.roleId ? getById.roleId : getById.allRoles[0]?.id,
                allRoles: getById.allRoles,
                loading: true
            });
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    };

    handleSelect = (e) => {
        e.preventDefault();
        const roleId = parseInt(e.target.value);
        this.setState({
            ...this.state,
            [e.target.name] : roleId,
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { submit } = this.props;
        submit(this.state);
    };

    render() {
        const { t, type } = this.props;

        const selectDom = this.state.allRoles.length > 0 ? ( this.state.allRoles?.map((item) => {
            return (
                <option key={item.id} value={item.id} > {item.label} </option>
            )
        })) : ( <option value={null}>Loading ...</option> );

        return (
            <React.Fragment>
                { this.state.loading ? (
                    <form onSubmit={this.handleSubmit}>
                        <div className="form-group">
                            <label className="col-form-label">{t('username')}</label>
                            <input
                                type="text"
                                className="form-control"
                                name="username"
                                onChange={this.handleOnChangeInput}
                                value={this.state.username || ''}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="col-form-label">{t('firstName')}</label>
                            <input
                                type="text"
                                className="form-control"
                                name="firstName"
                                onChange={this.handleOnChangeInput}
                                value={this.state.firstName || ''}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label className="col-form-label">{t('lastName')}</label>
                            <input
                                type="text"
                                className="form-control"
                                name="lastName"
                                onChange={this.handleOnChangeInput}
                                value={this.state.lastName || ''}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label className="col-form-label">{t('email')}</label>
                            <input
                                type="email"
                                className="form-control"
                                name="email"
                                onChange={this.handleOnChangeInput}
                                value={this.state.email || ''}

                            />
                        </div>

                        <div className="form-group">
                            <label className="col-form-label">{t('role')}</label>
                            <select className="form-control" name="roleId" value={this.state.roleId} onChange={this.handleSelect}>
                                { !selectDom || selectDom }
                            </select>
                        </div>

                        <div className="form-group float-right">
                            <button type="submit" className={`btn ${ type === formType.CREATE ? "btn-success" : "btn-primary" }`}>
                                <i className={`fas ${ type === formType.CREATE ? "fa-plus-circle" : "fa-edit" }`}> </i> { type === formType.EDIT ? (t('save-changes')) : (t('create')) }
                            </button>
                        </div>
                    </form>
                ) : (
                    <div>
                        <Spinner animation={"border"} />
                        <p>Loading ...</p>
                    </div>
                ) }
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const { getById } = state.userReducer;
    return {
        getById
    }
};

export default withNamespaces()(connect(mapStateToProps)(UserForm));
